import { useEffect, useState } from "react";
import { errorNotify, sucessNotify } from "../../services/toast.notification";
import { ValidationErrorSpan } from "../../styles/global";
import { useForm } from "../../utility/useForm";
import { ManualPaymentForm, validategenerateBillForm } from "../../utility/validationRules";
import { FormProps } from '../../utility/types';
import Spinner from "../../components/_common/Spinner";
import { Col, Modal, Row } from "antd";
import FormContainer from "../../components/FormContainer/FormContainer";
import { InfoText, PaymentGatewayContainer } from "../machineInstalRequest/styles";
import { billSingularPay, generateSingularBill, getBillType, machineInstallManualPay } from "../../api/api";
import CustomSelect from "../../components/_common/CustomSelect";
import { payTypes } from "../../constants";
import CustomTextArea from "../../components/_common/CustomTextArea";
import { useAppSelector } from "../../redux/store/storehooks";

export const GenerateNewBillDialog: React.FC<FormProps> = ({visible,onSubmit,onCancel,payLoad,setShowDialog}) => {

    const { values, errors, handleChange, handleSubmit,setErrors,setValues } = useForm(validategenerateBillForm) as any
    const myStore = useAppSelector((state) => state)
    const [isLoading,setIsLoading] = useState(true);
    const [isSubmiting,setIsSubmiting] = useState(false);
    const [billType,setBillType] = useState<any>([]);


    const ValidationType = ({ type }: any) => {
        const ErrorMessage = errors[type]; 
        return (
            <ValidationErrorSpan erros={errors[type]}>{ErrorMessage}</ValidationErrorSpan>
        );
    };

    useEffect( ()=>{
        loadBillType();
    },[])


    const loadBillType = () => {
        
        getBillType()
        .then((result:any) => {
            setBillType(result.data.data);
            setIsLoading(false);
        }).catch((error:any) => {
            console.log(error);
            onCancel();
            errorNotify(error.response.data.errorMessage,undefined,5000)
        })

    }

    const onSubmitForm = (e:any) => {
        e.preventDefault();
  
        setIsSubmiting(true)

        let error= validategenerateBillForm(values);
        if (Object.keys(error).length == 0)
        {
            generateSingularBill(
                payLoad.labId,
                values.billType,
                values.title ? values.title : '',
                values.description ? values.description : '',
                values.amount   
            )
            .then((result:any) => {
                sucessNotify("اطلاعات با موفقیت ثبت شد",undefined,5000)
                setIsSubmiting(false)
                onCancel();
            })
            .catch((error) => {
              console.log(error);
              setIsSubmiting(false)
              errorNotify(error.response.data.errorMessage,undefined,5000)
            })

        }
        else
        {
            setErrors(error);
        }
        
    }



    return (
        <Modal
            visible={visible}
            onCancel={onCancel}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ style: { display: 'none' } }}
        >
            <>
                {isLoading === true && (
                            <Spinner/>
                )}
                {isLoading === false && (

                    <FormContainer title="ایجاد فاکتور" onSubmit={onSubmitForm} onCancel={() => setShowDialog(false)} isLoading={isLoading} isSubmiting={isSubmiting} >
                        

                        <Row>
                            <Col lg={24} md={24} sm={24} xs={24}>
                                <CustomSelect 
                                    name="billType"
                                    placeholder="نوع فاکتور"
                                    itemList={billType}
                                    value={values.billType || ""}
                                    onChange={handleChange}
                                    valueObjectField={"prk_ParsicBillType_AutoID"}
                                    displayObjectField={"str_Title"}
                                />
                                <ValidationType type="billType" />
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={24} md={24} sm={24} xs={24}>
                                <CustomTextArea
                                    name="title"
                                    placeholder="عنوان فاکتور"
                                    value={values.title || ""}
                                    onChange={handleChange}
                                />
                                <ValidationType type="title" />
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={24} md={24} sm={24} xs={24}>
                                <CustomTextArea
                                    name="amount"
                                    placeholder="مبلغ"
                                    value={values.amount || ""}
                                    onChange={handleChange}
                                />
                                <ValidationType type="amount" />
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={24} md={24} sm={24} xs={24}>
                                <CustomTextArea
                                    name="description"
                                    placeholder="توضیحات"
                                    value={values.description || ""}
                                    onChange={handleChange}
                                />
                                <ValidationType type="description" />
                            </Col>
                        </Row>

                    </FormContainer>

                )}
            </>
            
        </Modal>
    )
}